import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatStepper } from '@angular/material/stepper';
import { SiteSelectors } from '@next/core-lib/site';
import { Store } from '@ngrx/store';

import {
  Application,
  ApplicationGroup,
  DisallowedAccessSettings,
  NewRole,
} from '../../shared/models/authorizationService.model';
import { AppWizardModuleState } from '../models/app-wizard.model';
import {
  createNewApplication,
  getApplicationGroups,
  getApplicationRoles,
  getApplications,
} from '../store/actions/app-wizard.actions';
import {
  selectApplicationGroups,
  selectApplicationRoles,
} from '../store/selectors/app-wizard.selectors';

@Component({
  selector: 'app-wizard-create',
  templateUrl: './app-wizard-create.component.html',
  styleUrls: ['./app-wizard-create.component.scss'],
  standalone: false,
})
export class AppWizardCreateComponent implements OnInit {
  @ViewChild(MatStepper) stepper: MatStepper;

  pageTitle$ = this.store.select(SiteSelectors.selectPageTitle);
  applicationGroups$ = this.store.select(selectApplicationGroups);
  applicationRoles$ = this.store.select(selectApplicationRoles);
  applicationGroupFormGroup = this.formBuilder.group({
    appGroupNameCtrl: ['', Validators.required],
  });
  applicationNameFormGroup = this.formBuilder.group({
    appNameCtrl: ['', Validators.required],
  });
  applicationDescriptionFormGroup = this.formBuilder.group({
    appDescriptionCtrl: ['', Validators.required],
  });
  applicationRoleFormGroup = this.formBuilder.group({
    appRoleNameCtrl: ['', Validators.required],
  });
  applicationDisallowedRoleFormGroup = this.formBuilder.group({
    appDisallowedRoleNameCtrl: [''],
  });

  constructor(
    private readonly store: Store<AppWizardModuleState>,
    private formBuilder: FormBuilder,
  ) {}

  ngOnInit(): void {
    this.store.dispatch(getApplicationGroups());
    this.store.dispatch(getApplicationRoles());
  }

  complete() {
    const newApplication: Application = {
      applicationGroupId: (
        this.applicationGroupFormGroup.get('appGroupNameCtrl').getRawValue() as ApplicationGroup
      ).id,
      displayName: this.applicationNameFormGroup.get('appNameCtrl').value as string,
      description: this.applicationDescriptionFormGroup.get('appDescriptionCtrl').value as string,
      defaultRoleKey: (
        this.applicationRoleFormGroup.get('appRoleNameCtrl').getRawValue() as NewRole
      ).key,
      externalApiAccess: null,
      key: this.applicationNameFormGroup.get('appNameCtrl').value as string,
      disallowedAccess: null,
    };

    const disallowedAccessRole = this.applicationDisallowedRoleFormGroup.get(
      'appDisallowedRoleNameCtrl',
    ).value as string;
    if (typeof disallowedAccessRole != 'undefined' && disallowedAccessRole) {
      const disallowedRole: DisallowedAccessSettings = {
        profileTypes: [disallowedAccessRole],
      };
      newApplication.disallowedAccess = disallowedRole;
    }

    this.store.dispatch(createNewApplication({ newApplication }));
    this.stepper.next();
    this.store.dispatch(getApplications());
  }
}
